import { apiClient } from '../../../../lib/api-client';
import { ReportResult } from '../../../../types/ReportResult';

export async function apiGeneratePurchaseOrderReport(purchaseOrderID: number, pdfTitle?: string): Promise<ReportResult> {
    try {
        return await apiClient.get("report/purchase-order",
            {
                params:
                {
                    purchaseOrderID: purchaseOrderID,
                    pdfTitle: pdfTitle
                }
            });
    } catch (error: any) {
        return {
            isSuccess: false,
            errorMessage: error,
            data: ''
        };
    }
};
